import { useTranslation } from 'react-i18next';
import { CheckmarkIcon } from 'components/CustomIcon';
import { Container, Header, Body } from './StepReturnCancelled.styles';

export const StepReturnCancelled = (): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Container justify="center" direction="column" align="center">
      <CheckmarkIcon width={56} height={56} />
      <Header>{t('RETURN_REQUEST_CANCELLED')}</Header>
      <Body>{t('RETURN_REQUEST_CANCELLED_TEXT')}</Body>
    </Container>
  );
};
